(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["broek-cart-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('broek-shipping-progress')) {
    customElements.define('broek-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this.init(this.dataset.order);
      }
      init(total) {
        const amount = Number(total);
        const threshold = Number(this.dataset.feAmount);
        if (!Number.isFinite(amount) || amount < 0 || !Number.isFinite(threshold) || threshold <= 0) return;
        const remaining = Math.max(0, threshold - amount);
        const progress = Math.min(100, amount * 100 / threshold);
        const unlocked = amount >= threshold;
        this.dataset.order = String(amount);
        this.classList.toggle('cart_shipping_free', unlocked);
        this.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(Math.round(progress)));
        const bar = this.querySelector('.percent_shipping_bar');
        if (bar) bar.style.width = progress + '%';
        const message = this.querySelector('.free-shipping-message');
        if (!message) return;
        let formatted;
        try {
          const moneyFormat = this.dataset.moneyFormat || '';
          const amountToken = /\{\{\s*amount\s*\}\}/;
          formatted = amountToken.test(moneyFormat)
            ? moneyFormat.replace(amountToken, new Intl.NumberFormat('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(remaining / 100))
            : typeof window.Shopify?.formatMoney === 'function'
            ? window.Shopify.formatMoney(remaining, this.dataset.moneyFormat)
            : new Intl.NumberFormat(this.dataset.locale || 'en', {style: 'currency', currency: this.dataset.currency || 'EGP', currencyDisplay: 'narrowSymbol'}).format(remaining / 100);
        } catch (_) {
          formatted = (remaining / 100).toFixed(2) + ' ' + (this.dataset.currency || 'EGP');
        }
        message.textContent = unlocked ? this.dataset.messageUnlocked : this.dataset.messageLocked.replace('[amount]', formatted);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('keydown',event => {
    if (!['Tab','Escape'].includes(event.key)) return;
    const drawer = document.querySelector('.search___drawer');
    if (!drawer) return;
    const box = drawer.getBoundingClientRect();
    if (!box.width || box.right <= 0 || box.left >= innerWidth || getComputedStyle(drawer).visibility === 'hidden') return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); drawer.querySelector('.btn-search-close')?.click(); return; }
    const controls = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),[tabindex="0"]')).filter(el=>el.getClientRects().length && getComputedStyle(el).visibility!=='hidden');
    const first=controls[0],last=controls.at(-1);
    if (!first) return;
    if (!drawer.contains(document.activeElement) || (event.shiftKey&&document.activeElement===first) || (!event.shiftKey&&document.activeElement===last)) { event.preventDefault(); (event.shiftKey?last:first).focus(); }
  },true);
})();
  } catch(e) { console.error(e); }
})();

})();
